import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for organizations */
export type OrganizationsId = string & { __flavor: "OrganizationsId" };

/**
 * Represents the table public.organizations
 * @uniqueConstraints {"organizations_pkey":{"name":"organizations_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"organizations_slug_unique":{"name":"organizations_slug_unique","isPrimary":false,"isUnique":true,"columns":[{"name":"slug","definition":"slug","predicate":null}]},"organizations_slug_index":{"name":"organizations_slug_index","isPrimary":false,"isUnique":false,"columns":[{"name":"slug","definition":"slug","predicate":null}]}}
 */
export default interface OrganizationsTable {
  id: ColumnType<OrganizationsId, OrganizationsId, OrganizationsId>;

  name: ColumnType<string, string, string>;

  slug: ColumnType<string | null, string | null, string | null>;

  logo: ColumnType<string | null, string | null, string | null>;

  createdAt: ColumnType<Date, Date | string | undefined, Date | string>;

  metadata: ColumnType<string | null, string | null, string | null>;
}

export type Organizations = Selectable<OrganizationsTable>;

export type NewOrganizations = Insertable<OrganizationsTable>;

export type OrganizationsUpdate = Updateable<OrganizationsTable>;

export const organizationsId = z.string() as unknown as z.Schema<OrganizationsId>;

export const organizations = z.object({
  id: organizationsId,
  name: z.string(),
  slug: z.string().nullable(),
  logo: z.string().nullable(),
  createdAt: z.date(),
  metadata: z.string().nullable(),
});

export const organizationsInitializer = z.object({
  id: organizationsId,
  name: z.string(),
  slug: z.string().optional().nullable(),
  logo: z.string().optional().nullable(),
  createdAt: z.date().optional(),
  metadata: z.string().optional().nullable(),
});

export const organizationsMutator = z.object({
  id: organizationsId.optional(),
  name: z.string().optional(),
  slug: z.string().optional().nullable(),
  logo: z.string().optional().nullable(),
  createdAt: z.date().optional(),
  metadata: z.string().optional().nullable(),
});

// ── constraints for Organizations ─────────────────────────────────
export const OrganizationsConstraints = {
  organizations_pkey: {
    name: "organizations_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  organizations_slug_unique: {
    name: "organizations_slug_unique",
    isPrimary: false,
    isUnique: true,
    columns: [{ name: "slug", definition: "slug", predicate: null }],
  },
  organizations_slug_index: {
    name: "organizations_slug_index",
    isPrimary: false,
    isUnique: false,
    columns: [{ name: "slug", definition: "slug", predicate: null }],
  },
} as const;
export type OrganizationsConstraintsType = typeof OrganizationsConstraints;
